import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PGLoading1 from '../assets/images/pg-loading-1.png';
import PGLoading2 from '../assets/images/pg-loading-2.png';
import PGLoading3 from '../assets/images/pg-loading-3.png';
import PGLoading4 from '../assets/images/pg-loading-4.png';
import PGLoading5 from '../assets/images/pg-loading-4.png';

const propTypes = {
  progress: PropTypes.number.isRequired,
};

const LOADING_LINES = [
  "Here we go! We're scanning every nook and cranny of your site to find revenue optimization opportunities.",
  "Grab a coffee and give it a minute and you'll receive a monetization score and a custom list to boost your revenues.",
  "First, we're checking your ad server and it's setup.",
  "Hold on a sec, we have to make sure your site is policy compliant! We're scanning your site for hundreds of potential policy violations.",
  "Almost there! Doing the last scan on your auction setup to make sure you're earning the most from every ad impression."
];

const LOADING_IMAGES = [PGLoading1, PGLoading2, PGLoading3, PGLoading4, PGLoading5];

export default function Loading({ progress }) {
  const numOfLines = LOADING_LINES.length;
  const numOfImages = LOADING_IMAGES.length;

  return <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <Box sx={{ width: '400px', textAlign: 'center' }}>
      <img className="loading-img" src={LOADING_IMAGES[Math.min(numOfLines - 1, Math.floor(progress / (100 / numOfImages)))]} alt="loading..." />
      <LinearProgress sx={{ width: '50%', my: 2, mx: 'auto' }} variant="determinate" value={progress} />
      <Typography sx={{ fontWeight: 700, fontSize: 24 }}>
        {LOADING_LINES[Math.min(numOfLines - 1, Math.floor(progress / (100 / numOfLines)))]}
      </Typography>
    </Box>
  </Box>;
}

Loading.propTypes = propTypes;